import { useQuery } from "@tanstack/react-query";
import { getAllFocus } from "../../services";

const ENDPOINT_URL = "/api/assessments/focus/all";

export const useApiAllFocus = () => {
  const useReactQuery = () => {
    return useQuery({
      queryKey: [ENDPOINT_URL],
      queryFn: () => getAllFocus(),
    });
  };

  return {
    useQuery: useReactQuery,
  };
};
